import type { CurrencyAdapter, RateAgainstUsdResult } from './currency-adapter'

export const usdAdapter: CurrencyAdapter = {
  code: 'USD',
  rateAgainstUSD(receiptDateIso: string): Promise<RateAgainstUsdResult> {
    return Promise.resolve({
      rate: 1,
      effectiveDate: receiptDateIso,
      source: 'identity',
    })
  },
}
